import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Ingresos from '../views/Ingresos.vue'
import Egresos from '../views/Egresos.vue'
import Despachos from '../views/Despachos.vue'
import MovimientosInternos from '../views/MovimientosInternos.vue'
import Trazabilidad from '../views/Trazabilidad.vue'
import Inventario from '../views/Inventario.vue'
import Instalaciones from '../views/Instalaciones.vue'
import Analytics from '../views/Analytics.vue'
import CostManagement from '../views/CostManagement.vue'
import Orders from '../views/Orders.vue'
import Users from '../views/Users.vue'
import OperatorDashboard from '../views/OperatorDashboard.vue'
import OperatorStorageDashboard from '../views/OperatorStorageDashboard.vue'
import PickingAssignment from '../views/PickingAssignment.vue'
import ServiceAssignment from '../views/ServiceAssignment.vue'
import IntelligentPicking from '../views/IntelligentPicking.vue'
import StorageExecution from '../views/StorageExecution.vue'
import WavePicking from '../views/WavePicking.vue'
import Recepciones from '../views/Recepciones.vue'
import store from '../store'
// La visibilidad de módulos se evalúa vía el getter del store (edition/isModuleVisible)

const routes = [
  {
    path: '/',
    redirect: '/inventario'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/ingresos',
    name: 'Ingresos',
    component: Ingresos,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/recepciones',
    name: 'Recepciones',
    component: Recepciones,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'], module: 'recepciones' }
  },
  {
    path: '/egresos',
    name: 'Egresos',
    component: Egresos,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'], module: 'egresos' }
  },
  {
    path: '/despachos',
    name: 'Despachos',
    component: Despachos,
    meta: { requiresAuth: true, allowedRoles: ['admin'], module: 'despachos' }
  },
  {
    path: '/movimientos-internos',
    name: 'MovimientosInternos',
    component: MovimientosInternos,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/trazabilidad',
    name: 'Trazabilidad',
    component: Trazabilidad,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'viewer'] }
  },
  {
    path: '/inventario',
    name: 'Inventario',
    component: Inventario,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator', 'viewer'] }
  },
  {
    path: '/instalaciones',
    name: 'Instalaciones',
    component: Instalaciones,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'viewer'], module: 'analytics' }
  },
  {
    path: '/cost-management',
    name: 'CostManagement',
    component: CostManagement,
    meta: { requiresAuth: true, allowedRoles: ['admin'], module: 'cost-management' }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'viewer'], module: 'orders' }
  },
  {
    path: '/picking-assignment',
    name: 'PickingAssignment',
    component: PickingAssignment,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/service-assignment',
    name: 'ServiceAssignment',
    component: ServiceAssignment,
    meta: { requiresAuth: true, allowedRoles: ['admin'], module: 'service-assignment' }
  },
  {
    path: '/intelligent-picking',
    name: 'IntelligentPicking',
    component: IntelligentPicking,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'], module: 'intelligent-picking' }
  },
  {
    path: '/intelligent-picking/:id',
    name: 'IntelligentPickingExecution',
    component: IntelligentPicking,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'], module: 'intelligent-picking' }
  },
  {
    path: '/storage-execution/:id',
    name: 'StorageExecution',
    component: StorageExecution,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'] }
  },
  {
    path: '/wave-picking',
    name: 'WavePicking',
    component: WavePicking,
    meta: { requiresAuth: true, allowedRoles: ['admin'], module: 'wave-picking' }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/trazabilidad-dm',
    name: 'TrazabilidadDM',
    component: () => import('../views/TrazabilidadDM.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'warehouse_manager', 'traceability_officer', 'destination_manager', 'clinical_professional', 'quality_auditor', 'receiving_operator', 'picker'], module: 'trazabilidad-dm' }
  },
  {
    path: '/auditoria',
    name: 'Auditoria',
    component: () => import('../views/Auditoria.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'traceability_officer', 'quality_auditor'], module: 'auditoria' }
  },
  {
    path: '/consignaciones',
    name: 'Consignaciones',
    component: () => import('../views/Consignaciones.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'traceability_officer', 'warehouse_manager', 'destination_manager', 'quality_auditor'], module: 'consignaciones' }
  },
  {
    path: '/cumplimiento',
    name: 'Cumplimiento',
    component: () => import('../views/Cumplimiento.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'traceability_officer', 'quality_auditor', 'warehouse_manager'], module: 'cumplimiento' }
  },
  {
    path: '/destinos',
    name: 'Destinos',
    component: () => import('../views/Destinos.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'traceability_officer'], module: 'destinos' }
  },
  {
    path: '/mi-servicio',
    name: 'MiServicio',
    component: () => import('../views/MiServicio.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'traceability_officer', 'destination_manager', 'clinical_professional', 'warehouse_manager'], module: 'mi-servicio' }
  },
  {
    path: '/documentos-dte',
    name: 'DocumentosDTE',
    component: () => import('../views/DocumentosDTE.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'warehouse_manager', 'traceability_officer'], module: 'documentos-dte' }
  },
  {
    path: '/proveedores',
    name: 'Proveedores',
    component: () => import('../views/Proveedores.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'warehouse_manager', 'traceability_officer'], module: 'proveedores' }
  },
  {
    path: '/empresa',
    name: 'CompanySettings',
    component: () => import('../views/CompanySettings.vue'),
    meta: { requiresAuth: true, allowedRoles: ['admin', 'warehouse_manager'] }
  },
  {
    path: '/operator',
    name: 'OperatorDashboard',
    component: OperatorDashboard,
    meta: { requiresAuth: true, allowedRoles: ['operator'] }
  },
  {
    path: '/operator-storage-dashboard',
    name: 'OperatorStorageDashboard',
    component: OperatorStorageDashboard,
    meta: { requiresAuth: true, allowedRoles: ['operator'] }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navegación guard para verificar autenticación y permisos
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters['auth/isAuthenticated']
  const currentUser = store.getters['auth/currentUser']
  
  if (requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }
  
  if (to.path === '/login' && isAuthenticated) {
    // Redirigir según el rol del usuario
    if (currentUser?.role === 'operator') {
      next('/operator')
    } else {
      next('/inventario')
    }
    return
  }
  
  // Verificar permisos por rol. `allowedRoles` se diseñó para los roles legacy
  // (admin/operator/viewer). Los roles granulares nuevos no se bloquean aquí: la
  // seguridad real la aplica el backend (permisos) y el menú se filtra por capacidad.
  const LEGACY_ROLES = ['admin', 'operator', 'viewer', 'user']
  const allowedRoles = to.meta.allowedRoles
  if (allowedRoles && currentUser && LEGACY_ROLES.includes(currentUser.role) && !allowedRoles.includes(currentUser.role)) {
    // Redirigir a la página apropiada según el rol
    if (currentUser.role === 'operator') {
      next('/operator')
    } else {
      next('/inventario')
    }
    return
  }

  // Bloquear módulos según los dos ejes (precios/operarios) del producto.
  // Evita el acceso por URL directa a rutas que no corresponden a la configuración.
  const moduleKey = to.meta.module
  if (moduleKey && !store.getters['edition/isModuleVisible'](moduleKey)) {
    next(currentUser?.role === 'operator' ? '/operator' : '/inventario')
    return
  }

  next()
})

export default router
